import { axiosClient } from "@/shared/api/axios-client";
import type { SolicitudDetalle } from "@/lib/types";

/**
 * Endpoints del ciclo de envío a autorización de una solicitud.
 *
 * `enviar` se llama una vez (transición ProvisionalmenteListo →
 * ListoParaAutorizacion). `reenviar` se llama tras un rechazo
 * (RechazadaParaCorreccion → continúa desde nivel donde fue rechazada,
 * preservando autorizaciones previas · decisión 37).
 */
export const envioAutorizacionApi = {
  enviar: (solicitudId: string) =>
    axiosClient
      .post<SolicitudDetalle>(`/api/solicitudes/${solicitudId}/enviar-a-autorizacion`)
      .then((r) => r.data),

  reenviar: (solicitudId: string) =>
    axiosClient
      .post<SolicitudDetalle>(`/api/solicitudes/${solicitudId}/reenviar`)
      .then((r) => r.data),
};
